import { ButtonPrimary } from "components/Atoms/Button";
import React, { useEffect } from "react";
import { PlaceholderContent } from "supportbeacon/articleplaceholders";
import { useApi } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { PreviewPanel, PreviewPanelContent, PreviewPanelFooter, PreviewPanelHeader } from "../PreviewPanel";
import AppointmentPhase from "components/Atoms/AppointmentPhase";
import { PreviewPanelDetailRow } from "components/Atoms/details/PreviewPanelDetailRow";
import ShowDateTime from "show/components/ShowDateTime";
import { ArtistPreview } from "../Company/CompanyPreviewPanel";

interface ExternalEventPreviewPanelProps {
  externalEventId: number
}

const ExternalEventPreviewPanel = (props: ExternalEventPreviewPanelProps) => {
  const { externalEventId } = props

  const api = useApi(() => window.CoreApi.ExternalCalendar.ExternalEvent(externalEventId), ["externalevent", externalEventId], {
    startEnabled: true
  });

  useEffect(() => {
    api.refetch();
  }, [externalEventId]);

  if (api.isInitialLoading) {
    return <>
      <PreviewPanelHeader title={RESX.ExternalCalendar.ExternalEvent} />
      <PreviewPanelContent>
        <PlaceholderContent />
      </PreviewPanelContent>
      <PreviewPanelFooter />
    </>;
  }

  const { externalEvent, calendar } = api.data;

  return <>
    <PreviewPanelHeader title={RESX.ExternalCalendar.ExternalEvent} />
    <PreviewPanelContent>
      {externalEvent.artist && <PreviewPanelDetailRow labelTop={site.currentEnvironment.functionGroups.artist.singular}>
        <ArtistPreview
          companyId={externalEvent.artist.artistId}
          trigger={<a>{externalEvent.artist.name}</a>}
          fallbackIfNoPermission={<>{externalEvent.artist.name}</>}
        />
      </PreviewPanelDetailRow>}

      <PreviewPanelDetailRow labelTop={RESX.DateTime.lblDate}>
        <ShowDateTime
          dateTime={externalEvent.dateTime}
        />
      </PreviewPanelDetailRow>

      {externalEvent.summary && <PreviewPanelDetailRow labelTop={RESX.GeneralLabels.Title}>
        <span>{externalEvent.summary}</span>
      </PreviewPanelDetailRow>}

      <PreviewPanelDetailRow labelTop={RESX.Status.resxStatus}>
        <AppointmentPhase value={externalEvent.phase} displayLabel />
      </PreviewPanelDetailRow>

      <PreviewPanelDetailRow labelTop={RESX.DateTime.Calendar}>
        <span>{calendar.title}</span>
      </PreviewPanelDetailRow>

      <PreviewPanelDetailRow labelTop={RESX.GeneralLabels.Description}>
        <span style={{ whiteSpace: "pre-wrap" }}>{externalEvent.content}</span>
      </PreviewPanelDetailRow>

    </PreviewPanelContent>
    <PreviewPanelFooter>
      <ButtonPrimary href={routes.externalEvent_Detail(externalEventId).absolute} label={RESX.Buttons.DetailView} />
    </PreviewPanelFooter>
  </>
}

export interface ExternalEventPreviewProps {
  externalEventId: number
  trigger: JSX.Element
}

export const ExternalEventPreview = (props: ExternalEventPreviewProps) => {
  return <PreviewPanel
    trigger={props.trigger}
    size="medium"
    id={`external-event-preview-${props.externalEventId}`}
  >
    <ExternalEventPreviewPanel externalEventId={props.externalEventId} />
  </PreviewPanel>
}